import { forwardRef } from '@chakra-ui/system';

import { Box } from '@frontend/components';
import { AssistanceIcon } from '@frontend/components/src/components/mediaAndIcons/icons/iconSet';

import { AssistanceAvailableBackground } from './';

export const AssistanceIconWithBackground = forwardRef((props, ref) => {
  return (
    <Box position="relative" bottom={2} left={4} ref={ref} {...props}>
      <AssistanceAvailableBackground boxSize={4} top={0} right={0} />
      <AssistanceIcon
        boxSize="1.375rem"
        color="alert.assistance"
        top="0.3125rem"
        right="0.3125rem"
        position="absolute"
      />
    </Box>
  );
});
